import React, { useState } from 'react';
import PropTypes from 'prop-types';
import VideoTile from 'components/VideoTile';
import { renderImage, POSTER_IMAGE } from 'helpers/ImageHelper';
import PlayButton from '../PlayButton';

const Video = ({
  image,
  isHover,
  placeholder,
  play,
  route,
  segmentPlaylistButtonAction,
  seriesName,
  theme,
  video,
  breakpoint,
}) => {
  const [initalRender, setInitialRender] = useState(false);
  if (isHover && !initalRender) setInitialRender(true);
  const imageRenderer = opts => renderImage({ breakpoint, imageType: POSTER_IMAGE, ...opts });

  return (
    <div className={theme.videoContainer}>
      <div className={theme.previewContainer}>
        <div className={theme.imageContainer}>
          {initalRender && (
            <span className={!isHover ? theme.invisible : ''}>
              <VideoTile
                data-test="tile-video"
                id={`tile-video-${video}`}
                image={image}
                load
                loop
                play={play}
                renderImage={renderImage}
                timer={0}
                video={video}
                videoPosterStyle={theme.videoPoster}
              />
            </span>
          )}
          <span className={isHover ? theme.invisible : ''}>
            <VideoTile
              data-test="tile-video"
              id={`tile-video-${video}`}
              image={placeholder}
              renderImage={imageRenderer}
              videoPosterStyle={theme.videoPoster}
            />
          </span>
        </div>
        <PlayButton
          route={route}
          seriesName={seriesName}
          theme={theme}
          thinIcon
          segmentPlaylistButtonAction={segmentPlaylistButtonAction}
        />
      </div>
      <div className={theme.shadowOverlay} />
    </div>
  );
};

Video.propTypes = {
  breakpoint: PropTypes.string,
  image: PropTypes.string,
  isHover: PropTypes.bool,
  placeholder: PropTypes.string,
  play: PropTypes.bool,
  route: PropTypes.string,
  segmentPlaylistButtonAction: PropTypes.func,
  seriesName: PropTypes.string,
  theme: PropTypes.shape({}),
  video: PropTypes.string,
};

Video.defaultProps = {
  breakpoint: '',
  image: '',
  isHover: false,
  placeholder: '',
  play: false,
  route: null,
  segmentPlaylistButtonAction: () => {},
  theme: {},
  video: null,
};

export default Video;
